import { render } from "./VacationForm.vue?vue&type=template&id=3b5f81df"
import script from "./VacationForm.vue?vue&type=script&lang=js"
export * from "./VacationForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/christianbundgaard/dev/ideal-ventures/ideal-hr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__